import { Link } from 'react-router-dom';

export default function QualitySection() {
  const features = [
    {
      icon: 'ri-microscope-line',
      title: 'HPLC Testing',
      description: 'High-Performance Liquid Chromatography analysis ensures accurate purity verification and compound identification for every batch.',
      link: '/quality'
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'COA Access',
      description: 'Complete Certificate of Analysis documentation available for all products with detailed testing results and specifications.',
      link: '/quality'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Cold-Chain Shipping',
      description: 'Temperature-controlled logistics with insulated packaging and ice packs to maintain compound integrity during transit.',
      link: '/contact'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <p className="text-xs font-semibold text-primary-600 uppercase tracking-wider mb-3">
            Quality Assurance
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-navy-900 mb-4">
            Third-Party Tested.<br />Clinically Pure. Reliably Sourced.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-8 shadow-md hover:shadow-xl transition-all duration-300"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-primary-100 rounded-full mb-6">
                <i className={`${feature.icon} text-3xl text-primary-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                {feature.description}
              </p>
              <Link
                to={feature.link}
                className="text-primary-600 font-semibold text-sm inline-flex items-center hover:text-primary-700 cursor-pointer"
              >
                Learn More
                <i className="ri-arrow-right-line ml-1"></i>
              </Link>
            </div>
          ))}
        </div>

        {/* Trust Badges Strip */}
        <div className="mt-12 flex flex-wrap justify-center items-center gap-8">
          {[
            { icon: 'ri-verified-badge-line', text: 'ISO Certified' },
            { icon: 'ri-test-tube-line', text: 'Lab Tested' },
            { icon: 'ri-shield-star-line', text: 'Quality Guaranteed' },
            { icon: 'ri-global-line', text: 'Worldwide Shipping' }
          ].map((badge, index) => (
            <div key={index} className="flex items-center space-x-2">
              <i className={`${badge.icon} text-2xl text-primary-600`}></i>
              <span className="text-sm font-medium text-gray-700">{badge.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}